<div class="wrapper">
  <div class="state_field__wrapper" (click)="changeState()">
    <div class="slider" #slider
         [ngStyle]="{'left': ((option.selected) ? 40 : 0)+'px','background-color':(option.selected)?'#559765':'#fff'}"></div>
  </div>
  <strong [ngClass]="{active:option.selected}">{{getLabel()}}</strong>
</div>
